import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

@Component({
  selector: 'app-beforepayment-confirm-dialog',
  templateUrl: './beforepayment-confirm-dialog.component.html',
  styleUrls: ['./beforepayment-confirm-dialog.component.scss'],
  providers: [DatePipe]
})
export class BeforePaymentConfirmDialogComponent implements OnInit {
  myDate: any;
  currentUser: any;
  CountryName: any;
  constructor(private router: Router,
    public dialogRef: MatDialogRef<BeforePaymentConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe, private tokenStorageService: TokenStorageService
  ) {
    this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
  }

  ngOnInit() {
    ;
    this.currentUser = this.tokenStorageService.getUser();
    
    

  }
  closeModal(d: any) {
    if (d == 1) {
      this.dialogRef.close();
    } else {
      this.dialogRef.close();
      this.router.navigate(['']);
    }

  }
  // BackToHome(){

  //   //this.dialogRef.close();
  //  this.closeModal();
  //   this.router.navigate(['']);

  // }
}
